import { render, staticRenderFns } from "./regionalAgent.vue?vue&type=template&id=42757fe1&scoped=true"
import script from "./regionalAgent.vue?vue&type=script&lang=js"
export * from "./regionalAgent.vue?vue&type=script&lang=js"
import style0 from "./regionalAgent.vue?vue&type=style&index=0&id=42757fe1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42757fe1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\pj\\Platform\\xrcNet\\xrcNet_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42757fe1')) {
      api.createRecord('42757fe1', component.options)
    } else {
      api.reload('42757fe1', component.options)
    }
    module.hot.accept("./regionalAgent.vue?vue&type=template&id=42757fe1&scoped=true", function () {
      api.rerender('42757fe1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/devise/regionalAgent.vue"
export default component.exports